import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

import { ToolbarServiceParams } from './toolbar.types';

export const useToolbarService = ({
  onBack,
  goBackTo,
  className,
}: ToolbarServiceParams) => {
  const navigate = useNavigate();

  const toolbarClassname = classNames('toolbar', className);

  const onBackClicked = () => {
    if (onBack) return onBack();
    if (goBackTo) return navigate(goBackTo);
    throw new Error(
      'The prop "onBack" or "goBackTo" must be defined in the toolbar component.'
    );
  };

  return {
    onBackClicked,
    toolbarClassname,
  };
};
